import React from "react";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import Image from "../image/Image";
import useLinkTarget from "../../../hooks/useLinkTarget";
import { getImageLink } from "../../../utils/images";
import { getDefaultCtaKey } from "../../../utils/linkTarget";
import { decodeText } from "../../../utils/richText";

// Freely-authored teaser card (image, badge, title, text, link) — the ecom sibling of
// demo-ftl-base's cardTeaser, meant for 2-4-up Grid columns. Unlike productTeaser it is
// not bound to a product; the link target decides where it leads.
// Like the FTL teaser, title, text and image fall back to the link target's own data when
// they are not authored. The target is fetched here and only when something is missing, so
// fully authored cards and all other links in the SPA cost no extra request.
const CardTeaser = ({ currentLanguageCode, strings, badge, title, text, image, link = {} }) => {
    const hasImage = !!getImageLink(image);
    const needsTarget = !title || !text || !hasImage;
    const { target } = useLinkTarget(link, { enabled: needsTarget, normalize: true, lang: currentLanguageCode });

    const displayTitle = title || target.title;
    const displayText = text || target.text;
    const displayImage = hasImage ? image : target.image;
    // Authored label wins, else the target type's default (e.g. "Shop now" for a product).
    const ctaKey = getDefaultCtaKey(link.target?.field);
    const ctaLabel = link.label || (ctaKey && strings[ctaKey]);

    return (
        <div className="card h-100 border-0 shadow-sm overflow-hidden">
            {!!getImageLink(displayImage) && (
                <LinkWrapper linkNode={link} renderChildren>
                    <Image imageNode={displayImage} className="card-img-top w-100" style={{ aspectRatio: "16 / 9", objectFit: "cover" }} />
                </LinkWrapper>
            )}
            <div className="card-body">
                {badge && <span className="badge bg-purple text-dark text-uppercase mb-2">{decodeText(badge)}</span>}
                {displayTitle && <h3 className="card-title h5">{decodeText(displayTitle)}</h3>}
                {displayText && <p className="card-text text-muted">{decodeText(displayText)}</p>}
                {ctaLabel && (
                    <LinkWrapper linkNode={link} linkClass="fw-semibold">
                        {decodeText(ctaLabel)}
                    </LinkWrapper>
                )}
            </div>
        </div>
    );
};

export default connect()(multilanguage(CardTeaser));
